import '@scss/marketing/index.scss';
import './_icons';
// Section Specific Imports
import { init as initHomePage } from './_home';

document.addEventListener("DOMContentLoaded", () => {
    initHomePage();
});